module.exports = __webpack_public_path__ + "static/img/2.e09cc8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/checkin/2.png
// module id = AIir
// module chunks = 0